import { buildQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/adminpanel";

type NormalizeNumbersParams = {
    organizationId: number;
    carIds?: number[] | null;
};

type NormalizeNumbersResponse = {
    failedCarIds?: number[];
};

const listQuery = {
    orderby: ["id desc"],
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(
        `${resource}/getOrganizationNames${query}&withDeleted=true`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const getItem = (params: { id: string }) => {
    return Promise.all([orgItem(params), getOrganizations(params)]).then(([organization, settings]) => ({
        organization,
        ...settings,
    }));
};

const orgItem = (params: { id: string }) => {
    const query = buildQuery({ filter: { id: parseInt(params.id) } });
    return request(`${resource}/getOrganizationNames${query}`, { method: "GET" }).then(
        (data) => data && data.length > 0 && data[0],
    );
};

const getOrganizations = (params: { id: string }) => {
    const query = buildQuery({ filter: { id: parseInt(params.id) } });
    return request(`${resource}/getOrganizations${query}`, { method: "GET" }).then(
        (data) => data && data.length > 0 && data[0],
    );
};

const apply = (params: {}) => alertRequest(`${resource}/setOrganizationSettings`, body(params));

const normalizeNumbers = (params: NormalizeNumbersParams): Promise<NormalizeNumbersResponse> =>
    request(`${resource}/normalizeNumbers`, body(params), {
        shouldAlert: true,
        alertParams: { successAlerts: false, noContentAlerts: false },
    });

const completeSelfRegistration = (params: { id: string }) =>
    alertRequest(`${resource}/completeSelfRegistration`, body(params));

export { index, apply, getItem, normalizeNumbers, completeSelfRegistration };
